import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import NavLink from "react-bootstrap/NavLink"
import Image from 'react-bootstrap/Image'

function Referrals(props) {

    const [successMessage, setSuccessMessage] = React.useState(null)
    const [errorMessage, setErrorMessage] = React.useState(null)

    const partnerId = useSelector(state => state.instructor.instructor.platformID)
    const widgetName = useSelector(state => state.instructor.instructor.widgetName)
    const user = useSelector(state => state.user.userData)
    const dispatch = useDispatch()

    const [searchTerm, setSearchTerm] = React.useState("");
    const [searchResults, setSearchResults] = React.useState([]);

    const [isSending, setIsSending] = React.useState(false)

    const link = `sutrapro.com/invite?ref=${widgetName}`

    const [showCopyLink, setCopyLink] = React.useState(false);
    function handleWidgetLinkClick(e) {
        e.preventDefault()
        var input = document.createElement('input');
        input.setAttribute('value', link);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        setCopyLink(true);

        setTimeout(function() {
            setCopyLink(false);
        }, 2000);
    }
    

    const [show, setShow] = React.useState(false)

    return(
    <div className={props.className + (!widgetName ? " d-none" : "")}>

        <div className='d-lg-flex d-lg-column align-items-center'>
            <h2 className="font-weight-bold">Get $50 for every friend that signs up!</h2>
            <NavLink className='' href='#' onClick={() => setShow(true)}>Learn More</NavLink>
        </div>
        <h5>My referral link:&nbsp;<a href="#" onClick={handleWidgetLinkClick}>{link}</a>
                    
                </h5>
        <Modal size='lg' show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                {/* <Modal.Title>{viewModel.title}</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
            <Image 
              style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover", overflow: "hidden"}}
              src={"https://firebasestorage.googleapis.com/v0/b/sutra-prod.appspot.com/o/icons%2FScreen%20Shot%202021-01-04%20at%206.51.12%20PM.png?alt=media&token=8328979b-a050-4c33-95a1-27d02d1eef94"} />
                {/* <LoginSignupForm
                mode={props.mode}
                onComplete={onHide}
                /> */}
                
            </Modal.Body>
            
        </Modal>
        {/* <div className='d-flex d-row justify-content-between align-items-center mb-4'>
            <div>
                <h2 className="font-weight-bold">Get $50 for every friend that signs up!</h2>
                <h5>My referral link:&nbsp;<a href="#" onClick={handleWidgetLinkClick}>{link}</a>
                    
                </h5>
            </div>
        </div> */}
    </div>
    )
}

export {Referrals}

export default function ReferralsPage(props) {
    return (
        <div className="container">
            <Referrals {...props} showExtra={true} />
        </div>
        
    )
}

// export default PartnerConnections